"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var from_1 = require("rxjs/observable/from");
var operators_1 = require("rxjs/operators");
/**
 * @author by Gor.Hakobyan on 28-Nov-18.
 */
var HttpDocumentAuthorizationProviderService = /** @class */ (function () {
    function HttpDocumentAuthorizationProviderService(http, applicationPropertiesService) {
        this.http = http;
        this.applicationPropertiesService = applicationPropertiesService;
        this.meServiceUriKey = "me-de-service-url";
        this.meServiceUri$ = from_1.from(this.applicationPropertiesService.getProperty(this.meServiceUriKey));
    }
    HttpDocumentAuthorizationProviderService.prototype.getAuthInfo = function (categorySystemName, indicatorId, documentSystemName) {
        var _this = this;
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) { return _this.http.get(url + "/users/token/" + categorySystemName + "/" + indicatorId + "/" + documentSystemName); }));
    };
    HttpDocumentAuthorizationProviderService.prototype.getUploadAuthInfo = function (categorySystemName, indicatorId, documentSystemName) {
        var _this = this;
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) { return _this.http.get(url + "/users/token/upload/" + categorySystemName + "/" + indicatorId + "/" + documentSystemName); }));
    };
    HttpDocumentAuthorizationProviderService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_authentication_client_js_1.HttpClientWrapper,
            idm_application_properties_service_client_js_1.ApplicationPropertiesService])
    ], HttpDocumentAuthorizationProviderService);
    return HttpDocumentAuthorizationProviderService;
}());
exports.HttpDocumentAuthorizationProviderService = HttpDocumentAuthorizationProviderService;
//# sourceMappingURL=http-document-authorization-provider.service.js.map